// /pages/AboutPage.tsx
export default function AboutPage() {
  return (
    <div className="max-w-2xl mx-auto py-12 px-4">
      <h1 className="text-2xl font-bold mb-4">A-Blind 소개</h1>
      <div className="text-gray-800 leading-relaxed">
        <b>A-Blind</b>는 예술가와 예술 종사자, 예술을 사랑하는 모두가<br />
        안전하게 소통하고 영감을 나눌 수 있는 익명 커뮤니티입니다.<br /><br />
        자유로운 대화와 네트워킹,<br />
        정보공유를 위한 다양한 게시판과 특별한 익명 ABtalk 등<br />
        오직 예술인만을 위한 환경을 제공합니다.<br /><br />
        <b>익명성, 공정성, 신뢰성</b>을 바탕으로 <br />
        새로운 예술생태계를 함께 만들어갑니다.
      </div>
    </div>
  );
}
